import {FetchArticleUsageStateType, FetchArticleUsageStateTypes} from './fetch-article-usage-state.model';
import {useSelect, UseSelectStateChange} from 'downshift';
import {clsx} from 'clsx';
import {EvLabel} from '../../components/labels/ev-label';

interface Props {
  selected: FetchArticleUsageStateType | null;
  selectedChanged: (value: FetchArticleUsageStateType | null) => void;
}

const dropdownListElements: (FetchArticleUsageStateType | null)[] = [null, ...FetchArticleUsageStateTypes.list];

export function FetchArticleUsageStateDropdown(props: Props) {
  const selected = props.selected;
  const onStateChange: (changes: UseSelectStateChange<FetchArticleUsageStateType | null>) => void = (changes) => {
    if (changes.selectedItem === undefined) {
      return;
    }

    if (changes.selectedItem?.state !== selected?.state) {
      props.selectedChanged(changes.selectedItem ?? null);
    }
  };

  const {
    selectedItem,
    isOpen,
    highlightedIndex,
    getItemProps,
    getToggleButtonProps,
    getMenuProps,
  } = useSelect<FetchArticleUsageStateType>({
    items: dropdownListElements,
    selectedItem: selected,
    defaultSelectedItem: null,
    initialSelectedItem: selected,
    onStateChange: onStateChange,
  });

  return <>
    <div className="form-control
                    input-sm
                    flex
                    justify-between
                    cursor-pointer
                    text-center"
         {...getToggleButtonProps()}>
      {
        !selectedItem ?
          <span>-</span> :
          <EvLabel className="pt-1.5" labeltype={selectedItem.className}>
            {selectedItem.stateName}
          </EvLabel>
      }
      <span className="px-2">{isOpen ? <>&#8593;</> : <>&#8595;</>}</span>
    </div>
    <ul {...getMenuProps()}
        className={clsx({
          'absolute w-72 bg-white mt-1 shadow-md max-h-80 overflow-y-auto overflow-x-clip p-0 z-10': true,
          'hidden': !isOpen,
        })}>
      {isOpen && dropdownListElements.map((item, index) => (
        <li key={index}
            className={clsx({
              'py-2 px-3 shadow-sm flex flex-col': true,
              'bg-blue-300': highlightedIndex === index,
              'font-bold': selectedItem === item,
            })}
            {...getItemProps({item, index})}>
          {item === null ?
            <span className="w-full text-center">-</span> :
            <EvLabel className="pt-1.5" labeltype={item.className}>
              {item.stateName}
            </EvLabel>
          }
        </li>
      ))
      }
    </ul>
  </>;
}
